import BaseBoosterBehavior, { IBaseBoosterBehaviorPlayMeta } from './BaseBoosterBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { BoosterType } from '../BoosterType';
import Game from 'Game';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from 'Utility/Tracking/Track';
import { TransactionType } from 'Utility/Tracking/DataSet/Transaction';
import { IGameState } from '../../Game/IGameState';
import { Quests } from '../../Player/QuestType';
import { InventoryStateHelper } from 'State/Player/Inventory/InventoryStateHelper';
import { QuestStateHelper } from 'State/Player/Quests/QuestStateHelper';

export default class PlusFiveBoosterBehavior extends BaseBoosterBehavior {
    public static readonly cardsToAdd = 5;

    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        let cardsState = {
            ...state.levelState.cardsState,
        };

        const targets: string[] = [];

        cardsState = CardStateHelper.addNewCards(cardsState, PlusFiveBoosterBehavior.cardsToAdd, targets);

        // Trigger plus cards animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.PLUS_FIVE,
            cards: targets,
        });

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: cardsState,
            },
        };

        return this.consumeItemOrCoins(state);
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices[BoosterType.PLUS_FIVE];
    }

    public getInventoryItem(state: IGameState): number {
        return state.playerState.inventory[BoosterType.PLUS_FIVE];
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        track('transactionType', TransactionType.INVENTORY);
        // TODO: use InventoryStateHelper.consumeInventory instead
        let playerState = InventoryStateHelper.setBoosterPlusFive(
            state.playerState,
            state.playerState.inventory[BoosterType.PLUS_FIVE] - 1,
            { queueTask: false }
        );
        return {
            ...state,
            playerState,
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        super.trackCoinsSpent(state, 'tExtraCardsCoins');
        state = super.spendCoins(state);

        Game.sdk.gameTracking(FBTrackingEvent.TapOnBuyFiveCards);

        return {
            ...state,
            levelState: {
                ...state.levelState,
                boosterUses: {
                    ...state.levelState.boosterUses,
                    [BoosterType.PLUS_FIVE]: state.levelState.boosterUses[BoosterType.PLUS_FIVE] + 1,
                },
            },
        };
    }

    protected consumeItemOrCoins(state: IGameState): IGameState {
        track('tPlus5Used', 1, TrackMethod.ADD);
        track('mPlus5Used', 1, TrackMethod.ADD);

        let newState = {
            ...state,
            playerState: QuestStateHelper.incrementQuestProgressBy(state.playerState, Quests.USE_PLUS_5_CARDS, 1),
        };

        return super.consumeItemOrCoins(newState);
    }
}
